import React from "react";

export const OverwriteDynamicPropertyCheckbox = (props) => {
    const {isChecked, onCheck, label, name} = props;

    return (
        <div className='input-container'>
            <input type="checkbox"
                   name={name}
                   className="checkbox static-text"
                   checked={isChecked}
                   onChange={(e) => onCheck(e, name)}/>
            <label className='static-text' htmlFor={name}>
                {label}
            </label>
        </div>
    )
}